/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateCompetitionBodyOnboardingSectionGetStartedStepsInner } from './UpdateCompetitionBodyOnboardingSectionGetStartedStepsInner';
import {
    UpdateCompetitionBodyOnboardingSectionGetStartedStepsInnerFromJSON,
    UpdateCompetitionBodyOnboardingSectionGetStartedStepsInnerFromJSONTyped,
    UpdateCompetitionBodyOnboardingSectionGetStartedStepsInnerToJSON,
    UpdateCompetitionBodyOnboardingSectionGetStartedStepsInnerToJSONTyped,
} from './UpdateCompetitionBodyOnboardingSectionGetStartedStepsInner';
import type { UpdateCompetitionBodyOnboardingSectionInstantReward } from './UpdateCompetitionBodyOnboardingSectionInstantReward';
import {
    UpdateCompetitionBodyOnboardingSectionInstantRewardFromJSON,
    UpdateCompetitionBodyOnboardingSectionInstantRewardFromJSONTyped,
    UpdateCompetitionBodyOnboardingSectionInstantRewardToJSON,
    UpdateCompetitionBodyOnboardingSectionInstantRewardToJSONTyped,
} from './UpdateCompetitionBodyOnboardingSectionInstantReward';
import type { UpdateCompetitionBodyOnboardingSectionPrizePool } from './UpdateCompetitionBodyOnboardingSectionPrizePool';
import {
    UpdateCompetitionBodyOnboardingSectionPrizePoolFromJSON,
    UpdateCompetitionBodyOnboardingSectionPrizePoolFromJSONTyped,
    UpdateCompetitionBodyOnboardingSectionPrizePoolToJSON,
    UpdateCompetitionBodyOnboardingSectionPrizePoolToJSONTyped,
} from './UpdateCompetitionBodyOnboardingSectionPrizePool';

/**
 * Configuration for the competition onboarding experience
 * @export
 * @interface UpdateCompetitionBodyOnboardingSection
 */
export interface UpdateCompetitionBodyOnboardingSection {
    /**
     * Main title for the onboarding section
     * @type {string}
     * @memberof UpdateCompetitionBodyOnboardingSection
     */
    title?: string;
    /**
     * Description text for the onboarding section
     * @type {string}
     * @memberof UpdateCompetitionBodyOnboardingSection
     */
    description?: string;
    /**
     * Steps to help users get started
     * @type {Array<UpdateCompetitionBodyOnboardingSectionGetStartedStepsInner>}
     * @memberof UpdateCompetitionBodyOnboardingSection
     */
    getStartedSteps?: Array<UpdateCompetitionBodyOnboardingSectionGetStartedStepsInner>;
    /**
     * 
     * @type {UpdateCompetitionBodyOnboardingSectionInstantReward}
     * @memberof UpdateCompetitionBodyOnboardingSection
     */
    instantReward?: UpdateCompetitionBodyOnboardingSectionInstantReward;
    /**
     * 
     * @type {UpdateCompetitionBodyOnboardingSectionPrizePool}
     * @memberof UpdateCompetitionBodyOnboardingSection
     */
    prizePool?: UpdateCompetitionBodyOnboardingSectionPrizePool;
}

/**
 * Check if a given object implements the UpdateCompetitionBodyOnboardingSection interface.
 */
export function instanceOfUpdateCompetitionBodyOnboardingSection(value: object): value is UpdateCompetitionBodyOnboardingSection {
    return true;
}

export function UpdateCompetitionBodyOnboardingSectionFromJSON(json: any): UpdateCompetitionBodyOnboardingSection {
    return UpdateCompetitionBodyOnboardingSectionFromJSONTyped(json, false);
}

export function UpdateCompetitionBodyOnboardingSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCompetitionBodyOnboardingSection {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'getStartedSteps': json['getStartedSteps'] == null ? undefined : ((json['getStartedSteps'] as Array<any>).map(UpdateCompetitionBodyOnboardingSectionGetStartedStepsInnerFromJSON)),
        'instantReward': json['instantReward'] == null ? undefined : UpdateCompetitionBodyOnboardingSectionInstantRewardFromJSON(json['instantReward']),
        'prizePool': json['prizePool'] == null ? undefined : UpdateCompetitionBodyOnboardingSectionPrizePoolFromJSON(json['prizePool']),
    };
}

export function UpdateCompetitionBodyOnboardingSectionToJSON(json: any): UpdateCompetitionBodyOnboardingSection {
    return UpdateCompetitionBodyOnboardingSectionToJSONTyped(json, false);
}

export function UpdateCompetitionBodyOnboardingSectionToJSONTyped(value?: UpdateCompetitionBodyOnboardingSection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'getStartedSteps': value['getStartedSteps'] == null ? undefined : ((value['getStartedSteps'] as Array<any>).map(UpdateCompetitionBodyOnboardingSectionGetStartedStepsInnerToJSON)),
        'instantReward': UpdateCompetitionBodyOnboardingSectionInstantRewardToJSON(value['instantReward']),
        'prizePool': UpdateCompetitionBodyOnboardingSectionPrizePoolToJSON(value['prizePool']),
    };
}

